/* eslint-disable */
var $ = window.jQuery = jQuery = require('jquery');

import {
  mapGetters,
  mapState
} from 'vuex';

import axios from 'axios';
import toast from '@/services/toast';

export default {
  name: 'payment-history',
  components: {},
  props: [],
  data() {
    return {
      paymentHistory: null,
      loader: false,
      paymentHistoryResults: [],
      totalCount: '',
      nextStep: '',
      loadmoreData: {},
      userLoading: false,
      selectedValue: ''
    }
  },
  computed: {
    ...mapGetters([
      'getPaymentHistoryDetailsState'
    ]),
    getUserSubscription() {
      this.paymentHistory = this.$store.getters.getPaymentHistoryDetailsState.data
      return;
    },
    SetIntialStatus() {
      if (this.paymentHistory) {
        this.totalCount = this.paymentHistory.count
        this.nextStep = this.paymentHistory.next
        this.paymentHistoryResults = this.paymentHistory.results
      }
    }
  },
  mounted() {
    this.getUserSubscription
    this.SetIntialStatus
  },
  methods: {
    loadmoreUser(url) {
      this.userLoading = true
      axios.get(url)
        .then((response) => {
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          console.log(this.loadmoreData, this.nextStep)
          this.$set(this.paymentHistory, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.paymentHistoryResults.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
    filterByPayHistory() {
      this.userLoading = true
      this.$store.dispatch('paymentPaidFilterFun', { id: this.selectedValue })
        .then((response) => {
          this.paymentHistory = response.data.data
          this.userLoading = false
          console.log(response.data.data)
        })
    }
  },
  watch: {
    getUserSubscription() {
      return this.$store.getters.getPaymentHistoryDetailsState
    },
    SetIntialStatus() {
      if (this.paymentHistory) {
        this.totalCount = this.paymentHistory.count
        this.nextStep = this.paymentHistory.next
        this.paymentHistoryResults = this.paymentHistory.results
      }
    }
  }
}